// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Make sure your project has Tailwind CSS installed.
  You can include these styles in your index.css or App.css 
*/

@tailwind base;
@tailwind components;
@tailwind utilities;

@layer base {
  body {
    @apply antialiased;
  }
}

/* Custom fade-in for page elements */
.animate-in {
  animation-duration: 700ms;
  animation-fill-mode: both;
}

@keyframes fade-in {
  from { opacity: 0; }
  to { opacity: 1; }
}

@keyframes zoom-in {
  from { opacity: 0; transform: scale(0.95); }
  to { opacity: 1; transform: scale(1); }
}

@keyframes slide-in-from-left {
  from { transform: translateX(-20px); opacity: 0; }
  to { transform: translateX(0); opacity: 1; }
}

.fade-in { animation-name: fade-in; }
.zoom-in { animation-name: zoom-in; }
.slide-in-from-left { animation-name: slide-in-from-left; }`, "",{"version":3,"sources":["webpack://./src/index.css"],"names":[],"mappings":"AAAA;;CAEC;;AAED,cAAc;AACd,oBAAoB;AACpB,mBAAmB;;AAEnB;EACE;IACE,kBAAkB;EACpB;AACF;;AAEA,qCAAqC;AACrC;EACE,yBAAyB;EACzB,yBAAyB;AAC3B;;AAEA;EACE,OAAO,UAAU,EAAE;EACnB,KAAK,UAAU,EAAE;AACnB;;AAEA;EACE,OAAO,UAAU,EAAE,sBAAsB,EAAE;EAC3C,KAAK,UAAU,EAAE,mBAAmB,EAAE;AACxC;;AAEA;EACE,OAAO,4BAA4B,EAAE,UAAU,EAAE;EACjD,KAAK,wBAAwB,EAAE,UAAU,EAAE;AAC7C;;AAEA,WAAW,uBAAuB,EAAE;AACpC,WAAW,uBAAuB,EAAE;AACpC,sBAAsB,kCAAkC,EAAE","sourcesContent":["/* Make sure your project has Tailwind CSS installed.\n  You can include these styles in your index.css or App.css \n*/\n\n@tailwind base;\n@tailwind components;\n@tailwind utilities;\n\n@layer base {\n  body {\n    @apply antialiased;\n  }\n}\n\n/* Custom fade-in for page elements */\n.animate-in {\n  animation-duration: 700ms;\n  animation-fill-mode: both;\n}\n\n@keyframes fade-in {\n  from { opacity: 0; }\n  to { opacity: 1; }\n}\n\n@keyframes zoom-in {\n  from { opacity: 0; transform: scale(0.95); }\n  to { opacity: 1; transform: scale(1); }\n}\n\n@keyframes slide-in-from-left {\n  from { transform: translateX(-20px); opacity: 0; }\n  to { transform: translateX(0); opacity: 1; }\n}\n\n.fade-in { animation-name: fade-in; }\n.zoom-in { animation-name: zoom-in; }\n.slide-in-from-left { animation-name: slide-in-from-left; }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
